import { QueryClient } from "@tanstack/react-query";
import type { HttpError } from "./generated";

/** Retries failed queries up to 3 times, except client errors (4xx), which won't change on retry. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  const status = (error as Partial<HttpError> | null)?.statusCode ?? 0;
  if (status >= 400 && status < 500) return false;
  return failureCount < 3;
}

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: shouldRetry } },
});
